import { http, setFormData } from '@/utils/http'
import { EVENT_FETCH, EVENT_CREATE, EVENT_UPDATE, EVENT_ANALYTICS } from '@/store/actions/event'

const state = {
  events: [],
  eventsAnalytics: {
    country: null
  }
}

const getters = {
  events: (state, g, rS, rootGetters) => {
    const events = state.events.map(event => {
      event.state = rootGetters.stateName(event.state_id)
      event.location = rootGetters.locationField('name', event.location_id)
      event.agency = rootGetters.agencyName(event.agency_id)
      return event
    })

    return events
  },
  eventsAsOptions: state => (type, id) => {
    let events = state.events.filter(event => {
      return event[type + '_id'] === id && event.status !== 'unverified'
    })
    events = events.sort((a, b) => {
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    })
    return events.map(
      event => ({ text: event.title, value: event._id })
    )
  },
  eventField: state => (field = 'title', id) => { // get event [field] by id
    const event = state.events.find(event => event._id === id)
    return event !== undefined ? event[field] : ''
  },
  eventsByField: state => (field, value) => state.events.filter(event => event[field] === value),
  eventAnalytics: (state, g, rS, rootGetters) => (entity) => {
    let analytics = state.eventsAnalytics[entity]
    let refinedAnalytics = {
      history: {},
      overview: {}
    }

    // History
    refinedAnalytics.history.labels = Object.keys(analytics.history)
    refinedAnalytics.history.data = Object.values(analytics.history)

    // Overview
    refinedAnalytics.overview.labels = Object.keys(analytics.overview).map(item => {
      return analytics.overview[item].details.name
    })
    refinedAnalytics.overview.data = Object.keys(analytics.overview).map(item => {
      return analytics.overview[item].count
    })

    return refinedAnalytics
  }
}

const mutations = {
  [EVENT_FETCH]: (state, payload) => {
    state.events = [ ...payload ]
  },
  [EVENT_UPDATE]: (state, payload) => {
    const updatedAids = state.events.map(
      event => (event._id === payload._id ? Object.assign(event, payload) : event)
    )
    state.events = updatedAids
  },
  [EVENT_ANALYTICS]: (state, payload) => {
    const updatedAnalytics = { ...state.eventsAnalytics, [payload.entity]: payload.data }
    state.eventsAnalytics = updatedAnalytics
  }
}

const actions = {
  [EVENT_FETCH]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      http.get('event/read_all')
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(EVENT_FETCH, response.data)
            resolve(response)
          }
          else reject(response)
        })
    })
  },
  [EVENT_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('event/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) resolve(response)
          else reject(response)
        })
    })
  },
  [EVENT_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('event/update', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(EVENT_UPDATE, payload)
            resolve(payload)
          }
          else reject(response)
        })
    })
  },
  [EVENT_ANALYTICS]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload.params)
      http.post('event/analytics_by_' + payload.entity, params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(EVENT_ANALYTICS, { entity: payload.entity, data: response.data })
            resolve(payload)
          }
          else reject(response)
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
